const LocalesJobOpeningsEnum = Object.freeze({
  fr: "Offres d'emploi",
  de: 'Offene Stellen',
  cs: 'Volná pracovní místa',
  sk: 'Pracovné ponuky',
  es: 'Ofertas de empleo',
})

export default LocalesJobOpeningsEnum
